import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * Switch Component - Centralized toggle switch styling
 * 
 * Variants:
 * - default: Standard indigo theme (for general toggles)
 * - sandbox: Amber theme for sandbox/testing mode toggles
 */
const switchVariants = cva(
  "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-slate-600",
  {
    variants: {
      variant: {
        default: "data-[state=checked]:bg-indigo-500",
        sandbox: "data-[state=checked]:bg-amber-500",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Switch = React.forwardRef(({ className, variant, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(switchVariants({ variant, className }))}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch, switchVariants }
